import { render, staticRenderFns } from "./ModalConfiguracoesProducao.vue?vue&type=template&id=632fbe66"
import script from "./ModalConfiguracoesProducao.vue?vue&type=script&lang=js"
export * from "./ModalConfiguracoesProducao.vue?vue&type=script&lang=js"
import style0 from "./ModalConfiguracoesProducao.vue?vue&type=style&index=0&id=632fbe66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports